/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EfectoSecundarioPacienteDto } from '../../models/efecto-secundario-paciente-dto';

export interface FarmacosControllerGetEfectosSecundariosPacientePrograma$Params {
  programaUuid: string;
}

export function farmacosControllerGetEfectosSecundariosPacientePrograma(http: HttpClient, rootUrl: string, params: FarmacosControllerGetEfectosSecundariosPacientePrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EfectoSecundarioPacienteDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetEfectosSecundariosPacientePrograma.PATH, 'get');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EfectoSecundarioPacienteDto>>;
    })
  );
}

farmacosControllerGetEfectosSecundariosPacientePrograma.PATH = '/api/farmacos/efectos-secundarios/{programaUuid}';
